import CustomZObject from './CustomZObject.js';

export default class ZPatterns extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("pattern switch", (msg) => this.patternSwitch([msg]));
        this.newOutlet("pattern switched");
    }

    patternSwitch(n) {
        let zobject = this.zObject;
        n = Math.round(n);

        let subSequence = zobject.subSequence;
        while (true) {
            let parent = zobject.subSequence;
            if (parent.zObject) {
                zobject = parent.zObject;
            } else {
                subSequence = zobject.subSequence;
                break;
            }
        }

        this.sequencerEngine.switchToPattern(n-1, true, subSequence);
    }
}

